import React from 'react';
import { connect } from 'react-redux';
import withStyles from 'isomorphic-style-loader/lib/withStyles';
import s from './Statystyka.css';
import { Grid, Row, Col } from 'react-bootstrap';
import fetch from '../../core/fetch/fetch.server';
import waiting from '../../routes/paymentStatus/waiting-wheel-300x300.gif';
import GrayPanel from '../../components/GrayPanel/GrayPanel';
import _ from 'lodash';
import { layoutColorStyle, headerStyle, getThemeFromLocalStorage } from '../../components/utils/utils';
import { replaceMultipleSpaces } from '../../lib/utils';
import v from '../eservices/validators';
import { PanelStyle } from '../../constants';
import ModalAlert from '../eservices/ModalAlert';
import DistrictsPanel from '../../components/DistrictsPanel/DistrictsPanel';


const {
  leftCol,
  labelCol,
  inputCol,
  inputStyle,
  errorSpanStyle,
  rightCol,
  labelStyle,
  rowStyle,
} = PanelStyle;


class Statystyka extends React.Component {

  state = {
    selected_district: null,
    dates: {
      dateFrom: '',
      dateTo: '',
    },

    filteredDistricts: [],
    filter_text: '',
    
    colors: 'normal',
    sourceStyle: layoutColorStyle,
    style: {},

    errors: {},
    errorTitle: '',
    errorText: '',
    showError: false,

    isDistrictAdmin: false,
    isMounted: false,
  };

  validators = {
    dateFrom: [
      v.NotNull,
      v.MinDate(
        '2015-01-01',
        'Minimalna data: 2015-01-01!'
      ),
      v.MaxDate(
        new Date().toISOString().split("T")[0],
        'Data "od" nie może być z przyszłości!'
      )
    ],

    dateTo: [
      v.NotNull,
      v.MinDate(
        '2015-01-01',
        'Minimalna data: 2015-01-01!'
      ),
      v.MaxDate(
        new Date().toISOString().split("T")[0],
        'Data "do" nie może być z przyszłości!'
      )
    ]
  };


  async fetchDistrictServicesWrapper() {
    try {
      let isDistrictAdmin = false;
      let prefix = null;

      const filteredDistricts = Object.values(this.props.districts)
        .filter(district => district.showOnList || district.prefix === 'gmina_giapowo')
        .sort();

      if (this.props.userData.roles.includes('districtadmin')) {

        const url = `${process.env.API_URL}/districts/district_for_user/${this.props.userData.userId}/`;
        const resp = await fetch(url);
        const r = await resp.json();
        prefix = r.district;
        isDistrictAdmin = true;

      } else {

        prefix = filteredDistricts[0].prefix;

      }

      const selected_district = _.find(filteredDistricts, { prefix });

      if (selected_district) {

        this.setState({
          selected_district,
          isDistrictAdmin,
          filteredDistricts,
          isMounted: true,
        });

      } else {

        this.showDistrictServicesError();

      }
    } catch (err) {

      console.error(err);

    }
  }

  componentDidMount() {
    this.fetchDistrictServicesWrapper();
    const colors = getThemeFromLocalStorage();

    let sourceStyle = layoutColorStyle;

    let style = {
      color: sourceStyle[colors].color,
      display: 'block',
    };

    if (colors !== 'normal') {

      sourceStyle = headerStyle;
      style = {
        color: sourceStyle[colors].color,
        backgroundColor: sourceStyle[colors].backgroundColor,
        display: 'block',
      };

    }

    this.setState({ colors, sourceStyle, style });

  }

  onClick = async (prefix) => {
    const selected_district = _.find(this.props.districts, { prefix });

    if (selected_district) {

      this.setState({
        selected_district,
      });

    } else {

      this.showDistrictServicesError();

    }
  };

  districtFilterChange = (e) => {
    //zamiana kilku spacji na jedną
    const value = replaceMultipleSpaces(e.target.value);
    this.setState({ filter_text: value });
  };

  errorStyle = (errorField) => (
    {
      width: '100%',
      borderColor:
        Object.keys(this.state.errors).indexOf(errorField) > -1 &&
          this.state.errors[errorField] !== null &&
          this.state.errors[errorField].length > 0
          ? 'red'
          : '#ccc',
    }
  )

  renderErrorsInSpan = (errorField) => {
    return (    
      <div>
      {Object.keys(this.state.errors).indexOf(errorField) > -1 &&
      this.state.errors[errorField] !== null &&
      this.state.errors[errorField].length > 0
      ? this.state.errors[errorField].map((val) => (
        <span key={val} style={errorSpanStyle}>
          {val}
        </span>
      ))
      : null}
    </div>)
    }
    
  onChange = (e, group) => {
    const name = e.target.name;
    this.setState(
      {
        [group]: {
          ...this.state[group],
          [name]: e.target.value,
        },
      },
      () => this.validate(group, name, null),
    );
  };

  validate = (group, field = null, callback = null) => {
    let newState = null;

    if (field) {
      if (Object.keys(this.validators).indexOf(field) > -1) {

        const checks = this.validateField(group, field);

        newState = {
          errors: {
            ...this.state.errors,
            [field]: checks,
          },
        };
      }
    } else if (group) {

      const errors = this.validateGroup(group);
      newState = { errors };

    } else {

      let errors = {};

      const grupy = ['dates'];

      for (const g of grupy) {
        const err = this.validateGroup(g);
        errors = { ...errors, ...err };
      }

      newState = { errors: { ...errors } };

    }
    if (newState) {

      if (callback) {

        this.setState(newState, callback);

      } else {

        this.setState(newState);

      }
    }
  };

  validateField = (group, field) => {
    const checks = [];

    if (Object.keys(this.validators).indexOf(field) > -1) {

      for (const validator of this.validators[field]) {

        const check = validator(this.state[group][field]);

        if (check) checks.push(check);

      }
    }

    return checks;
  };

  validateGroup = group => {
    const fields = Object.keys(this.state[group]);
    const errors = {};

    for (const f of fields) {
      const checks = this.validateField(group, f);
      errors[f] = checks;
    }

    return errors;
  };

  formatDate = (dateStr) => {
    const [year, month, day] = dateStr.split("-");

    return `${day}-${month}-${year}`;
  };

  runReport = () => {
    const hasFieldErrors = this.hasErrors();

    if (hasFieldErrors) {
      this.setState({
        errorText: 'Uzupełnij pola obowiązkowe.',
        errorTitle: 'Błędnie wypełniony formularz.',
        showError: true,
      });

      return false;
    }
    
    const { selected_district, dates } = this.state;

    const url = `${process.env.API_URL}/eservices/statistics/${selected_district.prefix}?dateFrom=${this.formatDate(dates.dateFrom)}&dateTo=${this.formatDate(dates.dateTo)}`;

    fetch(url)
      .then(async (response) => {
        if (response.status !== 200) {

          let errorMessage = 'Wystąpił nieoczekiwany błąd podczas pobierania danych.';

          try {
            const data = await response.json();

            const errorDict = {
              'invalid_date_format': 'Nieprawidłowy format daty. Użyj formatu RRRR-MM-DD.',
              'invalid_date_range': 'Data "od" nie może być późniejsza niż data "do".',
              'future_date': 'Data nie może być z przyszłości.',
              'missing_parameters': 'Brak wymaganych parametrów dateFrom i dateTo.',
            };

            if (data.error) {
              errorMessage = errorDict[data.error_type] || errorMessage;
            }
          } catch (err) {
            return Promise.reject(Object.assign(new Error(errorMessage), { name: "ApiError" }));
          }

          return Promise.reject(Object.assign(new Error(errorMessage), { name: "ApiError" }));
        }
        
        return window.open(url, '_blank');

      })
      .catch((err) => {
        this.setState({
          errorText: err.name === "ApiError" ? err.message : 'Wystąpił nieoczekiwany błąd podczas pobierania danych.',
          errorTitle: 'Błąd pobierania danych.',
          showError: true,
        });
      });
  }

  onHide = () => this.setState({ showError: false });

  hasErrors = () => {
    for (const key of Object.keys(this.state.errors)) {
      if (this.state.errors[key].length > 0) return true;
    }

    return false;
  };

  showDistrictServicesError = () => {
    return this.setState({
      errorText: 'Wystąpił nieoczekiwany błąd podczas pobierania danych.',
      errorTitle: 'Błąd pobierania danych.',
      showError: true,
      isMounted: true,
    });
  }

  getDateInputWithError = (group, field, placeholder) => (
    <div style={{ textAlign: 'justify' }}>
      <input
        type="date"
        className="form-control"
        name={field}
        style={this.errorStyle(field)}
        value={this.state[group][field]}
        min="2015-01-01"
        max={new Date().toISOString().split("T")[0]}
        placeholder={placeholder}
        onChange={e => this.onChange(e, group)}
      />
      {this.renderErrorsInSpan(field)}
    </div>
  )

  render() {
    if (!this.state.isMounted) {
      return (
        <GrayPanel
          title="Trwa ładowanie zawartości..."
          bodyStyle={{ textAlign: 'center', marginTop: '100px', marginBottom: '100px' }}
        >
          <img alt="Loader" src={waiting} />
        </GrayPanel>
      );
    }

    return (
        <div className={s.sgContainer} style={this.state.style}>
          <Grid style={{ width: '100%' }}>
            <Row>
              { !this.state.isDistrictAdmin ?
                <Col xs={3}>
                  <DistrictsPanel
                    districts={this.state.filteredDistricts}
                    onClick={this.onClick}
                  />
                </Col>
              : null }

              <Col xs={!this.state.isDistrictAdmin ? 9 : 12}>
                <Row>
                  {this.state.selected_district ? <h4 style={{ textAlign: 'left' }}>
                    <b>{this.state.selected_district.name} - statystyka wykorzystania e-usług<br></br><br></br></b>
                  </h4> : null}
                </Row>
                
                <Row>
                  <table style={{ width: '100%' }}>
                    <thead style={{ width: '100%', textAlign: 'left' }}>
                      <tr>
                        <th style={{ padding: '10px' }} colSpan="4">Wybierz zakres dat:</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr>
                        <td style={{ width: '10%', textAlign: 'center' }}>Data od:</td>
                        <td style={{ width: '10%', textAlign: 'center' }}>
                          {this.getDateInputWithError('dates', 'dateFrom', 'Data od')}
                        </td>
                        <td style={{ width: '10%', textAlign: 'center' }}>Data do:</td>
                        <td style={{ width: '10%', textAlign: 'center' }}>
                          {this.getDateInputWithError('dates', 'dateTo', 'Data do')}
                        </td>
                        <td style={{ width: '60%' }}>
                          <button
                            type="button"
                            className='btn btn-primary'
                            style={{ marginLeft: '20px' }}
                            onClick={() => this.validate(null, null, this.runReport)}
                          >
                            Pobierz raport .xlsx
                          </button>
                        </td>
                      </tr>
                    </tbody>
                  </table>
                </Row>
                  
              </Col>
            </Row>
          </Grid>

          <ModalAlert
            title={this.state.errorTitle}
            bodyText={this.state.errorText}
            show={this.state.showError}
            name="errorModal"
            onHide={this.onHide}
          />
        </div>
      );
  }
}

const mapState = state => ({
  username: state.user ? state.user.username : '',
  districts: state.district.districts
});


export default withStyles(s)(connect(mapState)(Statystyka));



// WEBPACK FOOTER //
// src/routes/Statystyka/Statystyka.jsx